import { axiosInstance } from "../lib/axios";
import toast from "react-hot-toast";
import Cookies from "js-cookie";

export const postQueryRequest = async (formData) => {
  try {

    const accessToken = Cookies.get("accessToken");
    const res = await axiosInstance.post(
      `/query`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    toast.success("Successfully Registered!");
    return res.data?.data;

  } catch (err) {
    console.log(err.response?.data?.message);
    toast.error(err.response?.data?.message || "Something went wrong!");
  }
};
